import { Component, OnInit } from '@angular/core'
import { Router } from '@angular/router'
import { AuthenticationService } from '../../../_services/authentication.service'
import { RequestsService } from '../../../_shared/services/requests.service'
import { HelperFunctions } from '../../../_shared/utils/helper-functions'

declare var jQuery: any
@Component({
  selector: 'app-all-crop-data',
  templateUrl: './all-crop-data.component.html',
  styleUrls: ['./all-crop-data.component.scss'],
})
export class AllCropDataComponent implements OnInit {
  cropName: string
  country_id: string
  countryName: string
  message: string
  cropsData: any
  cropCount: number
  filteredCrops: any
  searchItem: string
  cropDescription: string
  file: any = null
  loading = false
  createCropIsSuccess: boolean
  createCropError: boolean
  requiredField: any = {
    crop: false,
    photo: false,
  }
  selectedLanguage: string = 'English'
  isLoadingCrops: boolean
  isAddingCrop: boolean
  chosenLanguage: string = 'English'

  constructor(
    private requestService: RequestsService,
    private authenticationService: AuthenticationService,
    private _router: Router,
    private helperFunctions: HelperFunctions
  ) {}

  quillConfig = {
    toolbar: [
      [{ list: 'ordered' }, { list: 'bullet' }],
      ['bold', 'italic', 'underline'],
      [{ header: 1 }, { header: 2 }],
      ['clean'],
      ['link', 'image', 'video'],
    ],
  }

  editorStyle = {
    height: '100px',
    marginBottom: '10px',
  }

  ngOnInit() {
    const currentUser = this.authenticationService.getCurrentUserValue()
    const { country_id, country } = currentUser
    this.country_id = country_id
    this.countryName = country
    this.cropDescription = ''
    this.getAllCrops()
  }

  onLanguageSelected(event) {
    this.selectedLanguage = event.target.value
    this.getAllCrops()
  }

  getAllCrops() {
    this.isAddingCrop
      ? (this.isLoadingCrops = false)
      : (this.isLoadingCrops = true)
    this.requestService
      .dash_get(`crops/${this.countryName}/${this.selectedLanguage}`, null)
      .subscribe((res) => {
        this.isLoadingCrops = false
        this.cropsData = res.data
        this.filteredCrops = res.data
        this.cropCount = res.data.length
      })
  }

  getProductDetails(cropName: string, selectedLanguage: string) {
    localStorage.setItem('crop_name', cropName)
    localStorage.setItem('selected_language', selectedLanguage)
    this._router.navigateByUrl('/crop-details')
  }

  onLanguageChosen(event) {
    this.chosenLanguage = event.target.value
  }

  createCrop(createCropForm) {
    this.loading = true
    let formData = new FormData()

    if (this.file) {
      formData.append('photo', this.file, this.file.name)
    }
    formData.append('crop', createCropForm.crops)
    formData.append('description', createCropForm.description)
    formData.append('language', this.chosenLanguage)

    this.requestService
      .dash_putWithImage(
        `crops/${this.countryName}/${this.chosenLanguage}`,
        formData
      )
      .subscribe(
        (response) => {
          this.loading = false
          this.isAddingCrop = true
          if (response.success == true) {
            this.createCropIsSuccess = true
            this.message = 'Crop added successfully'
            this.getAllCrops()
            const status = 'success'
            this.helperFunctions.displayAlert(this.message, status)
            this.resetAddCropModal()
          } else {
            this.createCropIsSuccess = false
            this.message = response.message
            this.createCropError = true
          }
        },
        (error) => this.handlerError(error)
      )
  }

  processImage(event) {
    const {
      target: { files },
    } = event
    if (
      files.length > 0 &&
      /\.(jpg|jpeg|png)$/i.test(files[0].name) &&
      files[0].size < 2000000
    ) {
      this.file = event.target.files[0]
    } else {
      this.requiredField.photo = true
    }
  }

  handlerError(error) {
    this.loading = false
    this.createCropError = true
    this.message = 'An error occured please try again later'
  }

  resetAddCropModal() {
    jQuery('#addCropModal').modal('hide')
    jQuery('#cropForm')[0].reset()
    this.createCropIsSuccess = false
    this.createCropError = false
    this.file = null
    this.isAddingCrop = false
    this.chosenLanguage = 'English'
  }

  filterCropFunction() {
    this.searchItem = jQuery('#searchCrop').val()
    this.filteredCrops = this.cropsData.filter(
      (input) =>
        input.crop.toLowerCase().indexOf(this.searchItem.toLowerCase()) !== -1
    )
  }

  public languages = ['English', 'Hindi', 'Gujarati', 'Marathi']

  onClickOutside() {
    jQuery(document).ready(() => {
      jQuery('#addCropModal').on('hidden.bs.modal', () => {
        this.resetAddCropModal()
      })
    })
  }
}
